import Vue from 'vue'
import { Picker, Dialog, Toast, Popup, DatetimePicker, Loading, Empty, NavBar } from 'vant'

Vue.use(Picker)
  .use(Toast)
  .use(Dialog)
  .use(Popup)
  .use(DatetimePicker)
  .use(Loading)
  .use(Empty)
  .use(NavBar)
